import { render, staticRenderFns } from "./favSong.vue?vue&type=template&id=4b7303c7"
import script from "./favSong.vue?vue&type=script&lang=js"
export * from "./favSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports